<template>
<div id="app">
    <FormulateForm 
    v-if="lang == 'en'"
    class="login-form"
    v-model="formValues"
    @submit="submitForm"
    >
    <button class="langbutton" @click="language"> <p class="margin:3px !important">{{langval}}</p></button>
    <h3 style="margin-top:10px">1. How would you describe your overall satisfaction with the UDE? </h3>
    <FormulateInput
    name="satisfaction"
    :options="{1: 'Very Satisfied ', 2: 'Satisfied',3: 'Neutral',4: 'Not Satisfied ',5: 'Very Unsatisfied '}"
    type="radio"
    validation="required"
    />

    <h3>2. What feature have you used in the UDE App?</h3>
    <FormulateInput
    v-model="feature_array"
    :options="{1: 'Query/Retrieve ', 2: 'View Study Images', 3: 'AI Services', 4:'Share Study Images',5:' Others '}"
    type="checkbox"
    class="nomargin"
    validation="required"
    ignored
    />
    <FormulateInput
        v-if="feature_array[0] === '5'||feature_array[1] === '5'||feature_array[2] === '5'||feature_array[3] === '5'||feature_array[4] === '5'"
        type="text"
        help="Others"
        name="featureOther"
        />
    <h3>3. What features would you expect to find in the UDE App? We’d love to hear from you. Please comment below and leave your contact information.</h3>
    <FormulateInput
        type="textarea"
        name="suggestion"
        validation="max:256|required"
        error-behavior="live"
        />
        <FormulateInput
        type="text"
        name="name"
        label="Name"
        validation="required"
        />
        <FormulateInput
        type="email"
        name="email"
        label="Email Address"
        validation="required"
        />
        <FormulateInput
        type="number"
        name="telephone"
        label="Phone number"
        validation="required"
        />
    <FormulateInput
        type="submit"
        name="Submit"
    />
    </FormulateForm>
    <FormulateForm 
    v-else
    class="login-form"
    v-model="formValues"
    @submit="submitForm"
    >
    <button class="langbutton" @click="language"> <p class="margin:3px !important">{{langval}}</p></button>
    <h3 style="margin-top:10px">1. 整體而言，對於使用 UDE 的體驗，您的滿意度為何？</h3>
    <FormulateInput
    name="satisfaction"
    :options="{1: '非常滿意', 2: '有點滿意',3: '一般',4: '有點不滿意',5: '非常不滿意 '}"
    type="radio"
    validation="required"
    />

    <h3>2. 您今天使用了哪項功能?</h3>
    <FormulateInput
    v-model="feature_array"
    :options="{1: '查詢/取回', 2: '影像瀏覽', 3: 'AI 服務', 4:'影像分享',5:' 其他'}"
    type="checkbox"
    class="nomargin"
    validation="required"
    ignored
    />
    <FormulateInput
        v-if="feature_array[0] === '5'||feature_array[1] === '5'||feature_array[2] === '5'||feature_array[3] === '5'||feature_array[4] === '5'"
        type="text"
        help="Others"
        name="featureOther"
        />
    <h3>3. 您期望UDE增加哪方面的服務，以及建議？請留下您的聯絡資訊，以利回覆。</h3>
    <FormulateInput
        type="textarea"
        name="suggestion"
        validation="max:256"
        error-behavior="live"
        />
        <FormulateInput
        type="text"
        name="name"
        label="姓 名"
        validation="required"
        />
        <FormulateInput
        type="email"
        name="email"
        label="Email地址"
        validation="required"
        />
        <FormulateInput
        type="number"
        name="telephone"
        label="電話"
        validation="required"
        />
    <FormulateInput
        type="submit"
        name="送出"
    />
    </FormulateForm>
</div>
</template>
<script>
import axios from 'axios'
export default {
    data:function(){
    const lang = localStorage.getItem('lang')
    return {
        lang:lang,
        langval:'',
        feature_array:[], //taking a temporary arr to store feature on string with commas
        formValues: {
          feature:'',
          createDate: '',
          featureOther: null,
          suggestion:null,
          name: null,
          email:null,
          purpose: "1",
          purposeOther:null,
          telephone:null
        }
    }
  },
  metaInfo() {
        return { 
            title: "UDE",
            meta: [
                { name: 'description', content:  'Server. Viewer. Display. AI All in one iPad.'},
            ]
        }
    },
  created(){
    window.scrollTo(0, 0); //scroll to page top
    const lang = localStorage.getItem('lang')
    lang == 'en' ? this.langval = '中' : this.langval = 'EN'
  },
  methods:{
    language(){
            console.log(this.langval);
            if(this.langval=='EN'){
                localStorage.setItem('lang','en');
                this.langval='中'
            }
            else{
                localStorage.setItem('lang','ch');
                this.langval='EN'
            }
            window.location.reload()
    },
    submitForm(){
      console.log("Submitted");
      //this.formValues.id = Math.floor(Math.random() * (10 - 1) + 1); //for test purpose of id (remove in production)
      //getting value for createDate
      const saveDate = new Date();
      let month =saveDate.getMonth();
      let date = saveDate.getDate();
      let hours = saveDate.getHours();
      let minutes = saveDate.getMinutes();
      let seconds = saveDate.getSeconds();
      month++;
      month = ("0" + month).slice(-2);
      date = ("0" + date).slice(-2);
      hours = ("0" + hours).slice(-2);
      minutes = ("0" + minutes).slice(-2);
      seconds = ("0" + seconds).slice(-2);
      this.formValues.createDate = saveDate.getFullYear()+ "-" + month+ '-'+ date+'T'+ hours+':'+ minutes+':'+ seconds

      switch (this.formValues.satisfaction) {
          case '1':
            this.formValues.satisfaction='5';
            break;
          case '2':
            this.formValues.satisfaction='4';
            break;
          case '4':
            this.formValues.satisfaction='2';
            break;
          case '5':
            this.formValues.satisfaction='1';
            break;
        }
      console.log("form",this.formValues);
      //feature is sroted in array format so changing to string format
      let arr = this.feature_array;
      this.formValues.feature= arr.join();
      let res = axios.post('https://fhrweb.ebmtech.com/net/api/UDEFeedbacks',this.formValues)
        .then( console.log("res",res)
        )
        .catch(error=>{
          console.log(error);
        })
        alert('Thank you for your feedback!')
        window.location.reload()
      //send form to db
    }
  }
}
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
  margin-bottom: 20px;
}
.langbutton{
  float:right; margin:4px; padding:4px; border: 1px solid black; border-radius:5px;
}
.title{
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
h3{
  margin-top: 1em;
  margin-bottom: 1em;
}
.login-form {
  margin: 0.5em;
  padding: 1em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  margin: auto;
  width: 40%;
  box-sizing: border-box;
}
@media only screen and (max-width: 700px) {
.login-form {
  margin: 0.5em;
  padding: 1em;
  border: 1px solid #a8a8a8;
  border-radius: .5em;
  margin: auto;
  width: 95%;
  box-sizing: border-box;
}
}
.nomargin{
  margin-bottom: 0px;
}
.form-title {
  margin-top: 0;
}
.login-form::v-deep .formulate-input .formulate-input-element--textarea{
  max-width: none;
}
.floatleft{
  width: 25px;
}
</style>